import { type MouseEvent } from 'react'
import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { Body } from '@shipt/design-system-typography'
import { shadow5 } from '@/features/shared/styles/effects'
import { Button } from '@shipt/design-system-buttons'
import { Box } from '@shipt/design-system-layouts'

type Props = {
  toggleClearState: () => void
  onDeleteSuggestions: () => Promise<void>
}

export const ClearSearchSuggestions = ({ toggleClearState, onDeleteSuggestions }: Props) => {
  const handleCancelButtonClick = (e: MouseEvent) => {
    // prevent submitting form and triggering onBlur which closes the dropdown
    e.preventDefault()
    e.stopPropagation()
    toggleClearState()
  }

  const handleClearAllButtonClick = (e: MouseEvent) => {
    e.preventDefault()
    onDeleteSuggestions()
  }

  return (
    <Wrapper>
      <Box marginTop={0} marginBottom="xs">
        <Body strong>Clear all search history?</Body>
      </Box>
      <Box marginBottom="lg">
        <Body variant="secondary">
          Your search history makes it easier to find items. Are you sure you want to clear it?
        </Body>
      </Box>
      <ButtonsWrapper>
        <Button variant="secondary" size="sm" onClick={handleCancelButtonClick}>
          Cancel
        </Button>
        <Button size="sm" onClick={handleClearAllButtonClick}>
          Clear all
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${shadow5};
  margin: 0 16px;
  padding: 20px 16px 16px;
  border-radius: 8px;

  @media ${screenSizes.tablet} {
    margin: 0;
    border-radius: 0;
    box-shadow: none;

    &:hover,
    &:focus {
      box-shadow: none;
    }
  }
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`
